/**
 * 零件库存管理翻译 - 中文
 * Parts Inventory Management - Chinese
 */
export const partsZh = {
  // 模块名称
  title: '零件库存',
  subtitle: '零件库存管理系统',
  
  // 导航
  overview: '概览',
  management: '零件管理',
  create: '创建零件',
  inventoryOps: '库存操作',
  attributes: '属性管理',
  labelManagement: '标签管理',
  warehouseManagement: '仓库管理',
  stationManagement: '工位管理',
  
  // 概览页面
  totalParts: '总零件数',
  lowStock: '库存预警',
  outOfStock: '缺货',
  recentlyAdded: '最近添加',
  quickActions: '快捷操作',
  createPart: '创建零件',
  importParts: '批量导入',
  exportData: '导出数据',
  stockAlerts: '库存预警',
  recentParts: '最近零件',
  refreshData: '刷新数据',
  lastUpdated: '最后更新',
  
  // 表单区块
  coreInfo: '核心信息',
  coreInfoDesc: '所有零件必填的基础信息',
  groupInfo: '分组信息',
  groupInfoDesc: '根据所选分组生成的字段',
  
  // 零件列表
  partNumber: '零件编号',
  partName: '零件名称',
  partNameEn: '英文名称',
  partNameCn: '中文名称',
  category: '分类',
  currentStock: '当前库存',
  minStock: '最小库存',
  maxStock: '最大库存',
  unit: '单位',
  location: '位置',
  supplier: '供应商',
  price: '价格',
  stockStatus: '库存状态',
  actions: '操作',
  source: '来源',
  specifications: '规格',
  description: '描述',
  remark: '备注',
  station: '工位',
  warehouseLocation: '仓位',
  
  // Label 后缀版本（用于表格列标题等）
  partNumberLabel: '零件编号',
  partNameLabel: '英文名称',
  partNameCnLabel: '中文名称',
  specificationsLabel: '规格',
  stationLabel: '工位',
  warehouseLocationLabel: '仓位',
  currentStockLabel: '当前库存',
  minStockLabel: '最小库存',
  maxStockLabel: '最大库存',
  unitLabel: '单位',
  statusLabel: '状态',
  
  // 字段占位符
  partNumberPlaceholder: '请输入零件号',
  partNamePlaceholder: '请输入零件名称',
  partNameEnPlaceholder: '请输入英文名称',
  partNameCnPlaceholder: '请输入中文名称',
  unitPlaceholder: '如：个、台、米',
  sourcePlaceholder: '供应商或来源',
  specificationsPlaceholder: '请输入规格说明',
  descriptionPlaceholder: '请输入详细描述',
  remarkPlaceholder: '请输入备注信息',
  stationPlaceholder: '请输入工位',
  warehouseLocationPlaceholder: '请输入仓位',
  currentStockPlaceholder: '0',
  minStockPlaceholder: '0',
  maxStockPlaceholder: '可选',
  
  // 库存状态
  statusNormal: '正常',
  statusLow: '预警',
  statusOut: '缺货',
  statusActive: '启用',
  statusInactive: '禁用',
  discontinued: '停产',
  obsolete: '淘汰',
  
  // 筛选和搜索
  searchPlaceholder: '搜索零件编号、名称...',
  filterByGroup: '按分组筛选',
  filterByStatus: '按状态筛选',
  allGroups: '全部分组',
  allStatus: '全部状态',
  all: '全部',
  enterStation: '输入工位...',
  enterWarehouse: '输入仓位...',
  showFilters: '显示筛选',
  hideFilters: '隐藏筛选',
  clearFilters: '清除筛选',
  
  // 零件详情
  basicInfo: '基本信息',
  stockInfo: '库存信息',
  operationHistory: '操作历史',
  operationType: '操作类型',
  quantity: '数量',
  operator: '操作人',
  operationTime: '操作时间',
  operationRemark: '备注',
  
  // 操作类型
  opIn: '入库',
  opOut: '出库',
  opAdjust: '调整',
  opTransfer: '转移',
  opReturn: '退货',
  
  // 创建/编辑零件
  createNewPart: '创建新零件',
  editPart: '编辑零件',
  partInfo: '零件信息',
  selectGroup: '选择分组',
  selectGroups: '选择分组',
  pleaseSelectGroup: '请先选择零件分组',
  pleaseSelectGroupPlaceholder: '请选择分组',
  groupRequired: '分组为必填项',
  noGroup: '无分组',
  selectedGroups: '已选 {count} 个分组',
  fieldsCount: '{count} 个字段',
  noAvailableGroups: '暂无可用分组',
  locationPlaceholder: '如：A区-01-03',
  supplierPlaceholder: '供应商名称',
  pricePlaceholder: '单价',
  
  // 批量导入
  importing: '导入',
  downloadTemplateButton: '下载模板',
  creating: '创建中...',
  createPartButton: '创建零件',
  supportedFormats: '支持 Excel (.xlsx, .xls) 或 CSV',
  importSettings: '导入设置',
  updateExisting: '更新已存在的零件',
  switchToManual: '切换到手动创建',
  validating: '验证中...',
  validateData: '验证数据',
  startImport: '开始导入',
  validationSuccess: '验证通过',
  validationFailure: '验证失败',
  row: '第',
  rowError: '• 第 {row} 行: {error}',
  moreErrors: '...还有 {count} 个错误',
  importResults: '导入结果',
  total: '总计',
  success: '成功',
  failed: '失败',
  updated: '更新',
  errorDetails: '错误详情',
  returnToList: '返回列表',
  continueImport: '继续导入',
  dataPreview: '数据预览 ({count} 行)',
  moreRows: '...还有 {count} 行数据',
  parsingFile: '正在解析文件...',
  pleaseSelectExcel: '请选择要导入的Excel文件',
  importSuggestion: '建议先下载模板，按照模板格式填写数据后再导入',
  importTemplateFilename: '零件导入模板_{groupNames}.xlsx',
  
  // Toast 消息
  loadGroupsFailed: '加载分组失败',
  partNumberExists: '零件编号 "{partNumber}" 已存在',
  generateTemplateFailed: '生成模板失败',
  parsedRowsSuccess: '成功解析 {count} 行数据',
  parseExcelFailed: '解析Excel文件失败',
  readFileFailed: '读取文件失败',
  validationPassed: '数据验证通过',
  foundErrors: '发现 {count} 个错误',
  validationFailed: '验证失败',
  importSuccessCount: '成功导入 {count} 条记录',
  importFailed: '导入失败',
  pleaseEnterRequired: '请填写必填字段：零件编号和英文名称',
  minStockNegative: '最小库存不能为负数',
  currentStockNegative: '当前库存不能为负数',
  maxStockLessThanMin: '最大库存不能小于最小库存',
  
  // 库存操作
  inventoryOperations: '库存操作',
  inbound: '入库',
  outbound: '出库',
  selectPart: '选择零件',
  scanPart: '扫码零件',
  manualInput: '手动输入',
  scanInput: '扫码输入',
  selectInputMethod: '选择输入方式',
  searchByNumberOrName: '搜索零件编号或名称',
  scanOrEnterCode: '扫描或输入零件条码',
  selectOperationType: '选择操作类型',
  selectPartFirst: '请先选择零件',
  partNotFound: '未找到零件',
  operationPreview: '操作预览',
  operationDetails: '操作详情',
  afterOperation: '操作后',
  scanOperation: '扫码操作',
  scanOperationDesc: '使用扫码枪快速进行库存操作',
  adjustment: '调整',
  transfer: '转移',
  operationDate: '操作日期',
  operationQuantity: '操作数量',
  targetLocation: '目标位置',
  reason: '原因',
  reasonPlaceholder: '请输入操作原因',
  executeOperation: '执行操作',
  operationSuccess: '操作成功',
  operationFailed: '操作失败',
  
  // 时间相关
  createdAt: '创建时间',
  updatedAt: '更新时间',
  createdBy: '创建人',
  updatedBy: '更新人',
  
  // 时间格式化
  justNow: '刚刚',
  hoursAgo: '{hours} 小时前',
  daysAgo: '{days} 天前',
  
  // 预警
  alertLevel: '预警级别',
  alertType: '预警类型',
  alertTime: '预警时间',
  alertStatus: '预警状态',
  acknowledgeAlert: '确认',
  acknowledged: '已确认',
  unacknowledged: '未确认',
  
  // 属性管理
  partGroups: '零件分组',
  coreFields: '核心字段',
  customFields: '自定义字段',
  groupManagement: '分组管理',
  fieldManagement: '字段管理',
  createGroup: '创建分组',
  editGroup: '编辑分组',
  deleteGroup: '删除分组',
  addField: '添加字段',
  editField: '编辑字段',
  deleteField: '删除字段',
  
  // 页面和导航
  partManagement: '零件管理',
  inventoryOperation: '库存操作',
  attributeManagement: '属性管理',
  customFieldManagement: '自定义字段管理',
  columnManagement: '列配置',
  
  // 统计和状态
  activeParts: '活跃零件',
  lowStockParts: '低库存零件',
  outOfStockParts: '缺货零件',
  recentlyAddedTitle: '最近添加',
  stockAlertsTitle: '库存预警',
  noPermissionToViewStats: '无权查看统计数据',
  
  // 库存状态
  stock: '库存',
  stockInformation: '库存信息',
  stockStatusNormal: '正常',
  stockStatusLow: '低库存',
  stockStatusOut: '缺货',
  
  // 操作按钮
  viewParts: '查看零件',
  viewAllButton: '查看全部',
  goToButton: '前往',
  printLabel: '打印标签',
  printLabels: '打印标签',
  export: '导出',
  view: '查看',
  confirmDeleteSimple: '确认删除？',
  acknowledgeButton: '已确认',
  refreshing: '刷新中',
  
  // 快捷操作描述
  quickCreateDesc: '快速创建新零件',
  quickViewDesc: '查看和管理零件',
  quickInventoryDesc: '执行库存操作',
  
  // 搜索和筛选
  searchPlaceholderExtended: '搜索零件编号、名称或规格',
  searchGroups: '搜索分组',
  
  // 字段管理
  coreFieldsInfo: '核心字段',
  coreFieldsDesc: '所有零件必须包含的基础字段',
  manageFields: '管理字段',
  createField: '创建字段',
  fieldName: '字段名称',
  fieldGroup: '字段分组',
  associatedGroups: '关联分组',
  activeField: '启用',
  inactiveField: '停用',
  archivedField: '已归档',
  activateField: '启用字段',
  deactivateField: '停用字段',
  fieldUpdatedSuccess: '字段更新成功',
  fieldDeleteConfirm: '确定要删除此字段吗？',
  fieldDeletedSuccess: '字段已删除',
  noFieldsInGroup: '此分组暂无字段',
  sortable: '可排序',
  required: '必填',
  
  // 分组管理
  noGroups: '暂无分组',
  groupTip1: '分组用于组织零件类型',
  groupTip2: '每个分组可以有自定义字段',
  groupTip3: '点击分组查看和管理字段',
  
  // 列配置
  columnConfig: '列配置',
  configColumns: '配置列',
  createConfig: '创建配置',
  configName: '配置名称',
  myConfigs: '我的配置',
  publicConfig: '公共配置',
  teamTemplates: '团队模板',
  templateConfig: '模板配置',
  setAsDefault: '设为默认',
  setDefaultSuccess: '已设为默认配置',
  configCopiedSuccess: '配置已复制',
  configDeleteConfirm: '确定要删除此配置吗？',
  configDeletedSuccess: '配置已删除',
  
  // 导入相关
  import: '导入',
  selectFile: '选择文件',
  clickToSelectFile: '点击选择文件',
  templateDownloadSuccess: '模板下载成功',
  
  // 消息提示
  loadPartsFailed: '加载零件失败',
  createSuccessWithNumber: '创建成功，零件编号：{number}',
  createFailed: '创建失败',
  noDataMessage: '暂无数据',
  noAlertsMessage: '暂无预警',
  
  // 其他
  status: '状态',
  tips: '提示',
  noPartsFound: '未找到零件',
  loadingParts: '加载中...',
  partDeleted: '零件已删除',
  partSaved: '零件已保存',
  viewDetails: '查看详情',
  
  // 字段类型 (Field Types)
  fieldTypeText: '文本',
  fieldTypeNumber: '数字',
  fieldTypeDecimal: '小数',
  fieldTypeBoolean: '是/否',
  fieldTypeDate: '日期',
  fieldTypeDatetime: '日期时间',
  fieldTypeSelect: '单选下拉',
  fieldTypeMultiselect: '多选',
  fieldTypeTextarea: '多行文本',
  fieldTypeUrl: '链接',
  fieldTypeEmail: '邮箱',
  fieldTypePhone: '电话',
  fieldTypeFile: '文件',
  fieldTypeImage: '图片',
  fieldTypeRichText: '富文本',
  fieldTypeJson: 'JSON',
  
  // 字段表单 (Field Form)
  fieldKey: '字段标识',
  fieldKeyPlaceholder: '例如：material、color、weight',
  fieldKeyHint: '只能包含小写字母、数字和下划线',
  fieldNameChinese: '中文名称',
  fieldNameChinesePlaceholder: '例如：材质、颜色、重量',
  fieldNameEnglish: '英文名称',
  fieldNameEnglishPlaceholder: '例如：Material、Color、Weight',
  fieldType: '字段类型',
  fieldOptions: '选项',
  fieldDescription: '描述',
  fieldDescriptionPlaceholder: '字段的详细说明',
  fieldPlaceholder: '占位符',
  fieldPlaceholderPlaceholder: '输入框的占位符文本',
  fieldHelpText: '帮助文本',
  fieldHelpTextPlaceholder: '字段的帮助提示',
  enterOptionValue: '输入选项值',
  requiredField: '必填字段',
  visible: '可见',
  editable: '可编辑',
  searchable: '可搜索',
  
  // 分组表单 (Group Form)
  groupName: '分组名称',
  groupNamePlaceholder: '例如：电子元器件、机械零件等',
  groupDescriptionPlaceholder: '分组的详细描述',
  displayOrder: '显示顺序',
  displayOrderHint: '数字越小越靠前',
  enableGroup: '启用分组',
  
  // 详情页 (Detail Page)
  partDetails: '零件详情',
  basicInformation: '基本信息',
  identifierInfo: '标识信息',
  recordInfo: '记录信息',
  qrCode: '二维码',
  barcode: '条码',
  supplierPartNumber: '供应商料号',
  unitPrice: '单价',
  leadTime: '交期（天）',
  noOperationRecords: '暂无操作记录',
  stockLabel: '库存',
  backToList: '返回列表',

  // 标签管理
  labels: {
    emptyTitle: '没有找到零件',
    emptyDesc: '请调整筛选条件后重试',
  },

  // 分组选择器
  groupSelector: {
    title: '选择零件分组',
    description: '选择一个或多个分组，系统将根据分组生成对应的字段（可多选）',
    emptyTitle: '暂无可用分组',
    emptyDesc: '请先在属性管理中创建分组',
    loadFailed: '加载分组失败',
    selectedCount: '已选择 {count} 个分组',
  },
  
  // 错误消息 (Error Messages)
  pleaseEnterFieldKey: '请输入字段标识',
  pleaseEnterFieldName: '请输入字段名称',
  fieldKeyFormatError: '字段标识只能包含小写字母、数字和下划线',
  pleaseAddAtLeastOneOption: '请至少添加一个选项',
  pleaseEnterGroupName: '请输入分组名称',
  loadPartFailed: '加载零件失败',
  confirmDeletePart: '确认删除该零件？此操作不可恢复。',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  updateSuccess: '更新成功',
  updateFailed: '更新失败',
  updating: '更新中...',
  updateButton: '更新零件',
  exportSuccess: '导出成功',
  exportFailed: '导出失败',
  
  // Attributes page specific
  confirmDeleteGroup: '确定要删除分组"{name}"吗？',
  fieldCreatedSuccess: '字段创建成功',
  createFieldFailed: '创建字段失败',
  confirmDeleteField: '确定要删除字段"{name}"吗？',
  loadGroupDetailsFailed: '加载分组详情失败',
  loadFailed: '加载失败',
  retry: '重试',
  partsCount: '{count} 个零件',
  customFieldsCount: '{count} 个自定义属性',
  addNew: '新增',
};

export type PartsTranslations = typeof partsZh;
